// extracted by mini-css-extract-plugin
module.exports = {"content":"InputInterval_style_content__1Y0-o","area":"InputInterval_style_area__KMBnA","label":"InputInterval_style_label__IS1fU","line":"InputInterval_style_line__1H-mP"};